import classNames from 'classnames';
import moment from 'moment';

import {Stack} from '../../layout/stack/stack';
import type {StackSpacing} from '../../layout/stack/stack';
import {Body} from '../../typography/body';

import {CalendarHeatmapDates} from './calendar-heatmap-dates';
import {CalendarHeatmapWeekLabel} from './calendar-heatmap-week-label';
import type {CalendarHeatmapColorVariant, CalendarHeatmapDay} from './types';

export const CELL_WIDTH = 40;

export interface Props {
    dates: CalendarHeatmapDay[];
    onDateClick: (day: CalendarHeatmapDay) => void;
    hasBorder?: boolean;
    columnGap?: StackSpacing;
    rowGap?: StackSpacing;
    colorVariant?: CalendarHeatmapColorVariant;
}

export function CalendarHeatmap(props: Props) {
    const {hasBorder = true, columnGap = 16, rowGap = 8, colorVariant = 'blue'} = props;

    const containerStyles = classNames('width-fit-content', {
        'border br-8 pad-16': hasBorder,
    });

    return (
        <div className={containerStyles}>
            <Stack spacing={16} alignItems='center'>
                <Body size='large' isBold={true} textAlign='center'>
                    {moment(props.dates[0]?.date).format('MMMM YYYY')}
                </Body>
                <CalendarHeatmapWeekLabel cellGap={columnGap} />
                <CalendarHeatmapDates
                    onDateClick={props.onDateClick}
                    dates={props.dates}
                    columnGap={columnGap}
                    rowGap={rowGap}
                    colorVariant={colorVariant}
                />
            </Stack>
        </div>
    );
}
